import { render, staticRenderFns } from "./DevolucaoPage.vue?vue&type=template&id=70db36d0&scoped=true&"
import script from "./DevolucaoPage.vue?vue&type=script&lang=js&"
export * from "./DevolucaoPage.vue?vue&type=script&lang=js&"
import style0 from "./DevolucaoPage.vue?vue&type=style&index=0&id=70db36d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db36d0",
  null
  
)

export default component.exports